.signet-linear-indeterminate-loader {
  height: 4.5px;
  width: 100%;
  background: linear-gradient(var(--primary-main) 0 0),
    linear-gradient(var(--primary-main) 0 0), #dbdcef;
  background-size: 60% 100%;
  background-repeat: no-repeat;
  animation: indeterminate-linear-progress 3s infinite;
}

@keyframes indeterminate-linear-progress {
  0% {
    background-position: -150% 0, -150% 0;
  }

  66% {
    background-position: 250% 0, -150% 0;
  }

  100% {
    background-position: 250% 0, 250% 0;
  }
}

.signet-linear-determinate-loader {
  height: 4.5px;
  width: 100%;
  background: linear-gradient(var(--primary-main) 0 0) left/0% 100% no-repeat
    #dbdcef;
  animation: determinate-linear-progress 2s infinite linear;
}

@keyframes determinate-linear-progress {
  100% {
    background-size: 100% 100%;
  }
}
